const jielongRouter = [
    {
        path: '/jielongIntroDemo',
        name: 'JielongIntroDemo',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielong/JielongIntroDemo.vue'),
        meta: {
            title: '接龙介绍编辑器',
            deepth: 1
        }
    },
    {
        path: '/jieLongList',
        name: 'JieLongList',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielong/JieLongList.vue'),
        meta: {
            title: '接龙管理',
            deepth: 1
        }
    },
    {
        path: '/newJielong',
        name: 'NewJielong',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielong/newJielong.vue'),
        meta: {
            title: '新建接龙',
            deepth: 2
        }
    },
    {
        path: '/jielong/copy',
        name: 'JieLongCopy',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielong/JieLongList.vue'),
        props: { copyMode: true },
        meta: {
            title: '复制接龙',
            deepth: 2
        }
    },
    {
        path: '/jielong/selectGoods',
        name: 'SelectGoods',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielong/selectGoods.vue'),
        meta: {
            title: '选择商品',
            deepth: 3
        }
    },
    {
        path: '/jielongPreview',
        name: 'JielongPreview',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielong/JielongPreview/index.vue'),
        meta: {
            title: '接龙预览',
            deepth: 3
        }
    }
]
export default jielongRouter;